import React from "react";
import {
  FileKey2,
  FileTerminal,
  LockKeyhole,
  Settings,
  UserCircle,
} from "lucide-react";
import logoutIcon from "assets/images/SVG/logoutIcon.svg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { LogOutAdminAction } from "store/middlewares/session/auth";
import DefaultImg from "assets/images/PNG/blank.png";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "components/ui";
import checkAccess from "utils/checkAccess";
import { SmartImage } from "components/atoms";

const UserDropdownMenu = ({ trigger }) => {
  const { me } = useSelector((state) => state.me);
  const dispatch = useDispatch();

  // Use display data from currentUser
  const displayName = me?.name;

  const displayEmail = me?.email;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent className="w-64" side="bottom" align="end">
        {/* Header */}

        <div className="flex items-center justify-between p-3">
            <div className="flex items-center gap-2">
              <div className="size-10 overflow-hidden rounded-full border border-green-500 shrink-0">
                <div className="size-ful">
                  <SmartImage
                    src={me?.profile_url}
                    alt="profile"
                    size={38}
                    className="w-full h-full object-cover object-center"
                    fallback={
                      <div className="size-full rounded-full flex justify-center items-center">
                        <img
                          src={DefaultImg}
                          alt="profile"
                          className="w-full h-full img-cover"
                        />
                      </div>
                    }
                  />
                </div>
              </div>

              <div className="flex flex-col">
              <Link to="/public-profile/profile">
                {" "}
                <div className="text-sm text-mono hover:text-primary font-semibold break-all">
                  {displayName}
                </div>
              </Link>

              <div className="text-xs text-muted-foreground ">
                {displayEmail}
              </div>
            </div>
            </div>
          {/* <Badge variant="primary" appearance="outline" size="sm">
            Pro
          </Badge> */}
        </div>

        <DropdownMenuSeparator />

        {/* Menu Items */}
        <DropdownMenuItem asChild>
          <Link
            to="/public-profile/profile"
            className="flex items-center gap-2"
          >
            <UserCircle />
            My Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link
            to="/public-profile/change-password"
            className="flex items-center gap-2"
          >
            <LockKeyhole />
            Change Password
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings" className="flex items-center gap-2">
            <Settings />
            Settings
          </Link>
        </DropdownMenuItem>
        {checkAccess("read_terms") && (
          <DropdownMenuItem asChild>
            <Link to="/terms" className="flex items-center gap-2">
              <FileTerminal />
              Terms And Conditions
            </Link>
          </DropdownMenuItem>
        )}
        {checkAccess("read_privacy") && (
          <DropdownMenuItem asChild>
            <Link to="/privacy" className="flex items-center gap-2">
              <FileKey2 />
              Privacy Policy
            </Link>
          </DropdownMenuItem>
        )}
        {/* My Account Submenu */}
        {/* <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center gap-2 outline-transparent">
            <FileText />
            CMS
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="w-52">
            <DropdownMenuItem asChild>
              <Link
                to="/cms/terms"
                className="flex items-center gap-2"
              >
                <FileTerminal />
                Terms And Conditions
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/cms/privacy"
                className="flex items-center gap-2"
              >
                <FileKey2 />
                Privacy Policy
              </Link>
            </DropdownMenuItem>
          </DropdownMenuSubContent>
        </DropdownMenuSub> */}

        {/* <DropdownMenuItem asChild>
          <Link
            to="https://devs.keenthemes.com"
            className="flex items-center gap-2"
          >
            <SquareCode />
            Dev Forum
          </Link>
        </DropdownMenuItem> */}

        {/* Language Submenu with Radio Group */}
        {/* <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center outline-transparent gap-2 [&_[data-slot=dropdown-menu-sub-trigger-indicator]]:hidden hover:[&_[data-slot=badge]]:border-input data-[state=open]:[&_[data-slot=badge]]:border-input">
            <Globe />
            <span className="flex items-center justify-between gap-2 grow relative">
              Language
            </span>
          </DropdownMenuSubTrigger>
        </DropdownMenuSub> */}

        <DropdownMenuSeparator />

        {/* Footer */}
        <DropdownMenuItem
          className="hover:bg-transparent focus:bg-transparent"
          asChild
        >
          <div className="p-2 pb-0 mt-0">
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              onClick={() =>
                Swal.fire({
                  title: "Are you sure you want to logout?",
                  imageUrl: logoutIcon,
                  imageWidth: 80,
                  imageHeight: 80,
                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  customClass: {
                    popup: "custom-swal-popup",
                    title: "Swal-title-class",
                    confirmButton: "custom-swal-confirm",
                    cancelButton: "custom-swal-cancel",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(LogOutAdminAction());
                  }
                })
              }
            >
              Logout
            </Button>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdownMenu;
